<template>
  <div>
    <div class="box">
      <div class="box-header with-border">
        <div class="col-xs-12">
          <div class="col-xs-12 col-sm-6 text-left">
            <div class="form-group form-inline w-auto" v-if="brandBrief.length > 1 && $route.name !== 'storeInfo'">
              <select class="form-control h-38" v-model="brandSelect">
                <option value="0" v-if="roleType !== 10">== 品牌 ==</option>
                <option v-for="brand in brandBrief" :value="brand.value">
                  {{brand.label}}
                </option>
              </select>
            </div>
            <div class="form-group form-inline w-auto" v-if="brandSelect !== 0 && brandSelect !== '0' && storeBrief.length > 1">
              <select class="form-control h-38" v-model="storeSelect">
                <option value="0">== 店家 ==</option>
                <option v-for="store in storeBrief" :value="store.value">
                  {{store.label}}
                </option>
              </select>
            </div>
          </div>
          <div class=" col-xs-12 col-sm-6 text-right pull-right">
            <div class="form-group input-group time-box pull-right w-short">
              <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
              <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
              <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
              <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
              <span class="input-group-btn">
                  <button class="btn btn-default submit-btn btn-search" type="button"
                          id="search2" style="height: 72px" @click="clickSearch()">
                    <i class="fa fa-search"></i>
                  </button>
                </span>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <h3 class="box-title">訂單狀態轉移<span class="text-red text-12" v-if="(brandSelect === 0 || brandSelect === '0') && roleType === 99">(請選擇品牌或店家)</span></h3><br><br>
        </div>
        <div class="box-body p-0 col-xs-12">
          <div class="col-xs-12" style="overflow: scroll; max-height: 500px;">
            <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
              <thead>
              <tr>
                <th class="th-fit">日期</th>
                <th>購物車 > 送出訂單</th>
                <th>送出訂單 > 店家接/拒單</th>
                <th>樣本數</th>
              </tr>
              </thead>
              <tbody>
              <tr class="even" role="row" v-for="(transitTime, index) in transitTimeList">
                <td :rowspan="transitTime.reasonAmount" v-if="transitTime.date">{{getMonthDay(transitTime.date)}}</td>
                <td>{{getTimeString(transitTime.order_create_mean)}}</td>
                <td>{{getTimeString(transitTime.order_reply_mean)}}</td>
                <td><span v-if="transitTime.order_create_count">{{transitTime.order_create_count}}</span></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--
        <div class="box-header with-border">
          <div class="col-xs-12">
            <h3 class="box-title">今日拒絕接單統計<span class="text-red text-12" v-if="brandSelect === 99 || brandSelect === '99'">(請選擇品牌或店家)</span></h3><br><br>
          </div>
        </div>
        <div class="box-body p-0">
          <div class="col-xs-12" style="overflow: scroll; max-height: 500px;" v-if="rejectedOrderList">
            <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable" v-if="rejectedOrderList.length">
              <thead>
              <tr>
                <th class="th-fit">日期</th>
                <th>拒單原因 (狀態)</th>
                <th>筆數</th>
                <th>杯數</th>
                <th>金額</th>
              </tr>
              </thead>
              <tbody>
              <tr class="even" role="row" v-for="(reject, index) in rejectedOrderList">
                <td :rowspan="reject.reasonAmount" v-if="reject.date">{{getMonthDay(reject.date)}}</td>
                <td>{{reject.reject_reason}} ({{reject.reject_status}})</td>
                <td>{{reject.order_count}} 筆</td>
                <td>{{reject.item_count}} 杯</td>
                <td>{{reject.money}} 元</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-xs-12 text-right" v-if="rejectedOrderList">
            <div v-if="rejectedOrderList.length">
              <h6>共損失 {{total.orderCount}} 筆訂單</h6>
              <h6> {{total.itemCount}} 杯飲料</h6>
              <h6> {{total.money}} 元收入</h6>
            </div>
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'AAAA',
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      roleType: 99,
      brandSelect: 0,
      storeSelect: 0,
      // 1為brand取得過
      transitTime: 0,
      brandBrief: [],
      storeBrief: [],
      rejectedOrderList: [],
      transitTimeList: [],
      // date
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ]
    }
  },
  methods: {
    clickSearch () {
      if (this.brandSelect !== 0 && this.brandSelect !== '0') this.getTransitTime()
      if (this.roleType === 10) this.getTransitTime()
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (self.roleType === 10 && i === 0) self.storeSelect = sList[i].store_id
          }
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          var brandIds = ''
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            brandIds = brandIds + bList[i].brand_id + ','
          }
          brandIds = brandIds.slice(0, -1)
          if (self.roleType === 30) self.brandSelect = brandIds
          else if (self.roleType === 10) self.getStoreBrief(brandIds)
        }
      })
    },
    getTransitTime () {
      var self = this
      this.transitTimeList = []
      var data = {
        start: moment(this.menuTime.start.time).format('YYYYMMDD'),
        end: moment(this.menuTime.end.time).format('YYYYMMDD'),
        brandId: parseInt(this.brandSelect),
        storeId: parseInt(this.storeSelect)
      }
      var url = ''
      var infoType = ''
      if (data.brandId !== 99 && data.storeId === 99) {
        url = '/statistic/brandOrderTransitTime?start_date=' + data.start + '&end_date=' + data.end + '&brand_ids=' + data.brandId
        infoType = 'brand_info'
      } else if (data.brandId !== 99 && data.storeId !== 99) {
        url = '/statistic/storeOrderTransitTime?start_date=' + data.start + '&end_date=' + data.end + '&store_ids=' + data.storeId
        infoType = 'store_info'
      } else if (this.roleType === 10) {
        url = '/statistic/storeOrderTransitTime?start_date=' + data.start + '&end_date=' + data.end + '&store_ids=' + data.storeId
        infoType = 'store_info'
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          let tList = response.data.statistics
          for (let key in tList) {
            for (let n in tList[key][infoType]) {
              if (n === 0) {
                tList[key][infoType][n]['date'] = key
                tList[key][infoType][n]['reasonAmount'] = tList[key][infoType].length
              }
              self.transitTimeList.push(tList[key][infoType][n])
            }
          }
        }
      })
    },
    getMonthDay (date) {
      return moment(date, 'YYYY-MM-DD').format('MM/DD')
    },
    getTimeString (sec) {
      let min = Math.floor(sec / 60)
      let hour = Math.floor(sec / 3600)
      if (sec) {
        if (min === 0) return sec + ' 秒'
        else {
          if (hour === 0) return min + ' 分'
          else return hour + ' 小' + Math.floor(sec % 3600) + ' 分'
        }
      } else return ''
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    this.menuTime.start.time = moment().add(-1, 'weeks').format('YYYY-MM-DD')
    this.fixedH()
    let roleType = parseInt(this.getRoleType, 10)
    this.roleType = roleType
    this.getBrandBrief()
  },
  watch: {
    brandSelect () {
      this.storeSelect = 0
      if (this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getStoreBrief(this.brandSelect)
        if (this.storeSelect === 0 || this.storeSelect === '0') {
          this.transitTime = 1
          this.getTransitTime()
        }
      } else {
        this.transitTimeList = []
      }
    },
    storeSelect () {
      if (this.storeSelect !== 0 && this.storeSelect !== '0') this.getTransitTime()
      else if (this.transitTime === 0 && this.brandSelect !== 0 && this.brandSelect !== '0') this.getTransitTime()
      this.transitTime = 0
    },
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('31', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.menuTime.start.time).subtract(1, 'days'),
          to: moment(this.menuTime.end.time).add(1, 'days')
        }
      ]
    }
  }
}
</script>




// WEBPACK FOOTER //
// RejectReason.vue?7dbcc48e